<template>
  <div id="event-saloon-add-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
        <el-row v-else key="content-loading">
          <el-col v-if="$store.state.eventprogram.saloons.length > 0" :span="24">
            <div class="day-list-head">
              <div>
                <i class="el-icon-loading" v-if="loading == 'loadingOrder'"> </i>
              </div>
              <div>{{ $t("contentManagement.eventProgram.components.title") }}</div>
              <div class="d-flex justify-content-center">{{ $t("contentManagement.eventProgram.components.color") }}</div>
              <div class="d-flex justify-content-center">{{ $t("contentManagement.eventProgram.components.viewing") }}</div>
              <div></div>
            </div>
            <draggable :list="$store.state.eventprogram.saloons" class="day-list-container" handle=".el-icon-s-grid" @end="updateOrderNos">
              <div class="item" v-for="item in $store.state.eventprogram.saloons" :key="item.id" :class="{ passive: !item.isActive }">
                <div>
                  <i class="el-icon-loading burger" v-if="loading == item.id + '-listItem'"></i>
                  <i class="el-icon-s-grid burger" v-else></i>
                </div>
                <div>
                  <el-input v-model="item.title" @change="updateSaloon(item)" :class="$inputError('title', validationErrors)"></el-input>
                </div>
                <div class="justify-content-center">
                  <el-color-picker v-model="item.color" @change="updateSaloon(item)"></el-color-picker>
                </div>
                <div class="justify-content-center">
                  <el-switch v-model="item.isActive" @change="updateSaloon(item)"></el-switch>
                </div>
                <div class="btns justify-content-end">
                  <el-tooltip class="" effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteSaloon(item.id)" :confirm-button-text="$t('contentManagement.eventProgram.components.delete')" :cancel-button-text="$t('contentManagement.eventProgram.components.cancel')" icon="el-icon-info" icon-color="red" :title="$t('contentManagement.eventProgram.components.deleteSureMsg')">
                      <el-button type="danger" slot="reference" :loading="loading == item.id + 'deleteItem'" circle icon="fas fa-trash" size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </draggable>
          </el-col>
          <el-row v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-programs-lottie'" :title="$t('contentManagement.eventProgram.saloons')" @btnAdd="createSaloon" @btnRefresh="false" :buttonAdd="true" :buttonRefresh="false" :loading="loading" />
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.eventProgram.components.close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'loadingCreate'" :disabled="loading == 'loadingCreate'" @click="createSaloon">{{ $t("contentManagement.eventProgram.components.addSaloon") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "EventSaloonAddUpdate",
  components: {
    draggable
  },
  data() {
    return {
      validationErrors: [],
      loading: false,
      updateTimeOut: null
    };
  },
  created() {
    this.loading = "updateScreenLoading";
    if (this.updateTimeOut != null) clearTimeout(this.updateTimeOut);
    this.updateTimeOut = setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    async updateOrderNos() {
      this.loading = "loadingOrder";
      if (this.updateTimeOut != null) clearTimeout(this.updateTimeOut);
      this.updateTimeOut = setTimeout(async () => {
        var payload = [];
        this.$store.state.eventprogram.saloons.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("orderSaloons", payload);
        this.loading = false;
      }, 500);
    },
    async createSaloon() {
      this.loading = "loadingCreate";
      if (this.updateTimeOut != null) clearTimeout(this.updateTimeOut);
      this.updateTimeOut = setTimeout(async () => {
        var payload = { title: null, color: "#FF9900", isActive: false, id: null };
        if (this.$store.state.eventprogram.saloons.length > 0) {
          payload.title = this.$store.state.eventprogram.saloons.length + 1 + this.$t("dotSaloon");
        } else {
          payload.title = "1" + this.$t("dotSaloon");
        }
        var res = await this.$store.dispatch("addUpdateSaloon", payload);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    async updateSaloon(item) {
      this.loading = item.id + "-listItem";
      if (this.updateTimeOut != null) clearTimeout(this.updateTimeOut);
      this.updateTimeOut = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateSaloon", item);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    async deleteSaloon(id) {
      this.loading = id + "deleteItem";
      await this.$store.dispatch("deleteEventSaloon", id);
      this.loading = false;
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>
<style lang="less" scoped>
.event-day-add-update {
  padding: 1rem;
}
.day-list-head {
  display: grid;
  grid-template-columns: 36px 1fr 90px 90px 45px;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #f1f1f1;
  font-weight: bold;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.day-list-container {
  .item {
    & > div {
      display: flex;
      align-items: center;
    }
    .el-color-picker {
      width: 40px;
    }
    .el-date-editor {
      width: 100%;
    }
    margin-bottom: 8px;
    padding: 10px;
    gap: 0.5rem;
    transition: all 0.5s;
    border-radius: 8px;
    display: grid;
    grid-template-columns: 36px 1fr 90px 90px 45px;
    align-items: center;
    background-color: #f1f1f1;
    &.passive {
      background-color: #fff2f2 !important;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eventprogram/EventSaloonAddUpdate.vue